/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForGithub extends models.GovernanceConfigurationBaseForOperations {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForGithub.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForGithub>): GovernanceConfigurationBaseForGithub {
        let obj = Object.assign(new GovernanceConfigurationBaseForGithub(), model);
        GovernanceConfigurationBaseForGithub.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForGithub>): GovernanceConfigurationBaseForGithub {
        if (!model) return null;
        return GovernanceConfigurationBaseForGithub.newInstance(<GovernanceConfigurationBaseForGithub> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForGithub) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForGithub.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForGithub): boolean {
        if (models.GovernanceConfigurationBaseForOperations.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForGithub.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
